export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Puma Energy Foundation Annual Report 2024",
  "shortTitle": "",
  "description": "",
  "width": 622,
  "height": 810,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/2024",
  // "basePath": "",
  "companyLogo": "1-logo.png",
  "publishURL": "https://pumaenergyfoundation.touchline.org/2023/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/2024/static/_content/puma-energy-foundation-annual-report-2024.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 1-logo" style="top:6px;left:-26px;" src="/2024/static/_content/1-logo.png"/>
      <img class="abs halfScale 1-title" style="top:632px;left:301px;" src="/2024/static/_content/1-title-1.png"/>
      <img class="abs halfScale 1-title" style="top:667px;left:112px;" src="/2024/static/_content/1-year.png"/>

      `,
      "script": `
        function onPageEnter() {
        pg1Anim = new TimelineMax();
        pg1Anim.fromTo(cOf("1-logo"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
        .staggerFromTo(cOf("1-title"), 0.8, {opacity:0, x: -50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2);
        }

        function onPageLeave() {
        pg1Anim.stop();
        }
      `,
      "searchText": "2024 ANNUAL REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 3-title" style="top:370px;left:72px;" src="/2024/static/_content/3-title-1.png"/>
      
      <div class="addContentLink" onclick="Publish.goToPage(04);" style="top:423px; left:102px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(06);" style="top:460px; left:102px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(08);" style="top:500px; left:102px; width:180px; height:65px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:423px; left:370px; width:180px; height:50px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:482px; left:370px; width:180px; height:50px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:540px; left:370px; width:180px; height:25px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:580px; left:370px; width:180px; height:25px;"></div>

      `,
      "script": `
        function onPageEnter() {
        pg3Anim = new TimelineMax();
        pg3Anim.fromTo(cOf("3-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);

          setTimeout(function() {
          addContentLinks();
          },1000)
        }

        function onPageLeave() {
        pg3Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  03  ANNUAL REPORT 2024  CONTENTS 4 6 8   OPENING STATEMENT  OUR PARTNERS  CLEAN ENERGY We Care Solar Solar Sister Young Africa Barefoot College International  18   ROAD SAFETY Transaid World Bicycle Relief  24   OTHER PARTNERS CONEXION APROQUEN, INC  26 27  STAFF ENGAGEMENT  CONTACT & PHOTO CREDITS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
       <img class="abs halfScale 4-title" style="top:124px;left:57px;" src="/2024/static/_content/4-title-1.png"/>
       <img class="abs halfScale 4-title" style="top:159px;left:57px;" src="/2024/static/_content/4-title-2.png"/>
       <img class="abs halfScaleC 4-quote" style="top:177px;left:195px;" src="/2024/static/_content/4-quote-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim.staggerFromTo(cOf("4-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
        .fromTo(cOf("4-quote"), 0.6, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
        }

        function onPageLeave() {
        pg4Anim.stop();
        }
      `,
      "searchText": "04  OPENING STATEMENT I am pleased to have joined the Foundation Board and to contribute to this urgent work tackling vital health challenges. These overlooked areas of philanthropy have such a deep impact on the lives of millions and must be addressed.” MCEBISI JONAS  2024, as the first year of our updated 2024–2028 strategy, was a year of momentum for the Puma Energy Foundation. MCEBISI JONAS CHAIR OF THE FOUNDATION BOARD  The new strategy represents an evolution of our approach to focus and deepen our impact. To promote healthier communities, we focus on two priority areas: increasing access to clean energy and improving road safety. These two critical health issues are largely neglected by mainstream philanthropy but significantly affect vulnerable people all over the world. They are also relevant to Puma Energy’s work globally. We focus on road safety because unsafe roads are a worldwide crisis. 1.3 million people are killed in traffic collisions every year, making them the 10th leading cause of death worldwide – and the leading cause of death for children and youth between 5 and 29 years. Over 90% of these fatal incidents occur in low- and middle-income countries.  DARIO SOTO ABRIL EXECUTIVE DIRECTOR  Making clean energy widely available also has an outsized impact. Around the world, one in ten people lack access to electricity to light their homes, keep their food fresh or keep them warm. 2.6 billion rely on fuels that cause indoor air pollution, which is linked to 3.8 million premature deaths each year. Lack of access to clean energy also compounds other urgent issues like poverty, low levels of education and public health."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 5-quote" style="top:538px;left:207px;" src="/2024/static/_content/5-quote-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg5Anim = new TimelineMax();
        pg5Anim.fromTo(cOf("5-quote"), 0.6, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)
        }

        function onPageLeave() {
        pg5Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  05  ANNUAL REPORT 2024  To address these acute global challenges, we partner with organisations working in low- and middle-income countries in Africa and Latin America, with a particular focus on last-mile and off-grid communities. In 2024, we supported programmes in seven countries: Tanzania, Malawi, Mozambique, Guatemala, Ghana, Nicaragua and El Salvador. Our rigorous screening and selection process for nonprofit and social enterprise partners ensures that our grants have the most impact possible. Alongside progressing our strategy through existing partnerships, we took on three new partnerships this year: Transaid and World Bicycle Relief, as part of our road safety focus area, and We Care Solar, as part of our focus on advancing clean energy access for remote health facilities. We were also proud to support Puma Energy employees in Papua New Guinea to establish the first-ever Charity Committee to coordinate their philanthropic initiatives. You can read more about their progress so far on page 26. In addition, the Foundation leadership transitioned, with Mcebisi Jonas succeeding Pierre Lorinet as Chairman.  We are proud of the remarkable achievements of our partners in 2024, which continue to inspire and drive us forward. In 2025 and beyond, we are committed to continue implementing our strategy and better serve vulnerable communities across the world.  Mcebisi’s extensive leadership experience as Deputy Minister of Finance, Member of Parliament, and a key figure in provincial development initiatives in South Africa, will help steer the Foundation to success.” DARIO SOTO ABRIL"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `

       <h1 id="6-no" class="abs gotham-bold 6-no" style="top:656px;left:58px; font-size: 1.3em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 12820, "comma": true}' ></h1>
       <h1 id="6-no" class="abs gotham-bold 6-no" style="top:656px;left:225px; font-size: 1.3em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 7}' ></h1>
       <h1 id="6-no" class="abs gotham-bold 6-no" style="top:656px;left:314px; font-size: 1.3em; font-weight: 300; color: #04774c; padding: 0px; margin: 0px;"  data-number='{"to": 1, "preppend":"USD ", "append":" MILLION"}' ></h1>

       <img class="abs halfScaleC 6-icon" style="top:617px;left:44px;" src="/2024/static/_content/6-icon-1.png"/>
       <img class="abs halfScaleC 6-icon" style="top:618px;left:203px;" src="/2024/static/_content/6-icon-2.png"/>
       <img class="abs halfScaleC 6-icon" style="top:610px;left:302px;" src="/2024/static/_content/6-icon-3.png"/>

      `,
      "script": `
        function onPageEnter() {
        pg6Anim = new TimelineMax();
        pg6Anim.staggerFromTo(cOf("6-icon"), 0.8, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        .fromTo(cOf("6-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("6-no")[0])}}, 1.2)
        .fromTo(cOf("6-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("6-no")[1])}}, 1.4)
        .fromTo(cOf("6-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("6-no")[2])}}, 1.6)
        }

        function onPageLeave() {
        pg6Anim.stop();
        resetNumbers("6-no");
        }
      `,
      "searchText": "06  OUR PARTNERS In 2024, Puma Energy Foundation supported seven partners. At the end of the year, a new partnership with World Bicycle Relief was also approved, with funding set to begin in early 2025.  BAREFOOT COLLEGE INTERNATIONAL Guatemala  CONEXION El Salvador  APROQUEN Nicaragua  2024 IN NUMBERS 12,820  PEOPLE BENEFITING FROM OUR PARTNERS' PROGRAMMES  7  PARTNERS SUPPORTED  USD 1 MILLION  ANNUAL BUDGET  SINCE ITS INCEPTION IN 2013, THE FOUNDATION HAS INVESTED USD 11.8 MILLION IN PHILANTHROPIC PROGRAMMING."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  07  ANNUAL REPORT 2024  SOLAR SISTER Tanzania WE CARE SOLAR Malawi and Tanzania  YOUNG AFRICA Mozambique  WORLD BICYCLE RELIEF Zambia  TRANSAID Ghana  KEY ‘ACCESS TO CLEAN ENERGY’ PARTNERS  ‘ROAD SAFETY’ PARTNERS  OTHER PARTNERS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `

        <img class="abs halfScaleC 8-box" style="top:-468px;left:-185px;" src="/2024/static/_content/8-green-box.png"/>
      
        <img class="abs halfScaleC 8-title" style="top:53px;left:-111px;" src="/2024/static/_content/8-title-1.png"/>
        <img class="abs halfScaleC 8-title" style="top:158px;left:-149px;" src="/2024/static/_content/8-title-2.png"/>

        <img class="abs halfScaleC 8-text" style="top:268px;left:-65px;" src="/2024/static/_content/8-text-1.png"/>
        <img class="abs halfScaleC 8-text" style="top:375px;left:-61px;" src="/2024/static/_content/8-text-2.png"/>
        <img class="abs halfScaleC 8-text" style="top:494px;left:-46px;" src="/2024/static/_content/8-text-3.png"/>
        <img class="abs halfScaleC 8-text" style="top:570px;left:-54px;" src="/2024/static/_content/8-text-4.png"/>
        <img class="abs halfScaleC 8-text" style="top:660px;left:-63px;" src="/2024/static/_content/8-text-5.png"/>
        
        `,
      "script": `
        function onPageEnter() {
        pg8Anim = new TimelineMax();
        pg8Anim.fromTo(cOf("8-box"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("8-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.1)
        .staggerFromTo(cOf("8-text"), 0.7, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.4)
        }

        function onPageLeave() {
        pg8Anim.stop();
        }
      `,
      "searchText": "08  CLEAN ENERGY WE PARTNER with organisations that provide clean, reliable energy to rural, last-mile households and medical facilities in low- and middle-income countries in Africa and Latin America. This two-fold approach emphasises health, sustainability and community empowerment. Their household energy solutions reduce indoor air pollution and improve well-being by providing clean stoves, solar systems, microgrids, awareness campaigns and training. Strengthening local capacity ensures sustainable change and creates livelihood opportunities in rural areas. For remote health facilities, solutions such as solar powered lighting systems and medical equipment dramatically improve patient care and treatment outcomes. Without clean energy access, we cannot tackle issues like poverty, education and public health, which is why the Foundation invests in clean energy to address these challenges. The work with our various partners is described on the following pages."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 9-icon" style="top:68px;left:454px;" src="/2024/static/_content/9-icon-1.png"/>
      <img class="abs halfScaleC 9-text" style="top:156px;left:403px;" src="/2024/static/_content/9-text-1.png"/>
      <img class="abs halfScaleC 9-text" style="top:200px;left:418px;" src="/2024/static/_content/9-text-2.png"/>
      <img class="abs halfScaleC 9-text" style="top:254px;left:379px;" src="/2024/static/_content/9-text-3.png"/>
      <img class="abs halfScaleC 9-text" style="top:292px;left:360px;" src="/2024/static/_content/9-text-4.png"/>

      <img class="abs halfScaleC 9-icon" style="top:380px;left:454px;" src="/2024/static/_content/9-icon-2.png"/>
      <img class="abs halfScaleC 9-text" style="top:467px;left:344px;" src="/2024/static/_content/9-text-5.png"/>
      <img class="abs halfScaleC 9-text" style="top:512px;left:399px;" src="/2024/static/_content/9-text-6.png"/>
      <img class="abs halfScaleC 9-text" style="top:560px;left:336px;" src="/2024/static/_content/9-text-7.png"/>
      <img class="abs halfScaleC 9-text" style="top:632px;left:361px;" src="/2024/static/_content/9-text-8.png"/>
      <img class="abs halfScaleC 9-text" style="top:711px;left:318px;" src="/2024/static/_content/9-link-1.png"/>

      <div class="addContentLink" style="top:720px;left:411px;width:200px;height:10px">
        <a href="https://www.un.org/sustainabledevelopment/energy/" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:730px;left:411px;width:200px;height:30px">
        <a href="https://www.who.int/news-room/fact-sheets/detail/electricity-in-health-care-facilities/" target="_blank"></a>
      </div>



      `,
      "script": `
        function onPageEnter() {
        pg9Anim = new TimelineMax();
        pg9Anim.staggerFromTo(cOf("9-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.8, 1)
        .staggerFromTo(cOf("9-text"), 0.5, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)

          setTimeout(function(){
            addContentLinks();
          },3000)
        }

        function onPageLeave() {
        pg9Anim.stop();
        removeContentLinks();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  09  ANNUAL REPORT 2024  GLOBAL CHALLENGES 1 in 10  people lack access to electricity*  2.3  billion rely on fuels that cause indoor air pollution* Nearly  1 billion  people depend on health-care facilities that lack access to reliable electricity**  OUR PARTNERSHIPS’ 2024 IMPACT 9,451  people supplied with clean energy products  499  people trained as solar technicians, electricians and entrepreneurs, of which 89% are women  1  country programme launched to energise healthcare  * https://www.un.org/sustainabledevelopment/energy/ ** https://www.who.int/news-room/fact-sheets/detail/ electricity-in-health-care-facilities"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 10-title" style="top:111px;left:-132px;" src="/2024/static/_content/10-title-1.png"/>
      <img class="abs halfScaleC 10-title" style="top:147px;left:-92px;" src="/2024/static/_content/10-title-2.png"/>

      <img class="abs halfScaleC 10-text" style="top:270px;left:387px;" src="/2024/static/_content/10-text-1.png"/>
      <img class="abs halfScaleC 10-icon" style="top:302px;left:436px;" src="/2024/static/_content/10-icon-1.png"/>
      <img class="abs halfScaleC 10-text" style="top:346px;left:360px;" src="/2024/static/_content/10-text-2.png"/>
      <img class="abs halfScaleC 10-icon" style="top:395px;left:436px;" src="/2024/static/_content/10-icon-2.png"/>
      <img class="abs halfScaleC 10-text" style="top:440px;left:329px;" src="/2024/static/_content/10-text-3.png"/>
      <img class="abs halfScaleC 10-icon" style="top:489px;left:436px;" src="/2024/static/_content/10-icon-3.png"/>
      <img class="abs halfScaleC 10-text" style="top:533px;left:356px;" src="/2024/static/_content/10-text-4.png"/>
      <img class="abs halfScaleC 10-icon" style="top:583px;left:436px;" src="/2024/static/_content/10-icon-4.png"/>
      <img class="abs halfScaleC 10-text" style="top:621px;left:356px;" src="/2024/static/_content/10-text-5.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg10Anim = new TimelineMax();
        pg10Anim.staggerFromTo(cOf("10-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
        .staggerFromTo(cOf("10-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)
        .staggerFromTo(cOf("10-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5);
        }

        function onPageLeave() {
        pg10Anim.stop();
        }
      `,
      "searchText": "10  NEW  PA R  TN ER  BRIGHTER AND SAFER MATERNITY CARE WE CARE SOLAR PROGRAMME: LIGHT EVERY BIRTH LOCATIONS: Malawi and Tanzania  Every year, 300,000 women and over a million newborns die due to complications during pregnancy, primarily in Africa and Asia. An oftenoverlooked challenge for healthcare workers is electricity. An estimated 59% of health facilities in low- and middle-income countries lack reliable electricity or have no power source at all. Without power, emergency interventions are dangerous or impossible at night, and patients may be asked to pay for candles or kerosene, which they often cannot afford. Studies have shown that providing electricity to remote maternal and child health facilities contributed to a 50% decrease in maternal mortality and a 63% decrease in infant deaths. “To date, families have been asked to bring candles and/or flashlight batteries to health facilities at night,” stated Dr. Laura Stachel, the former obstetriciangynecologist who co-founded We Care Solar in 2010. “I have witnessed the heart-breaking loss of mothers and newborns due to the lack of light in labour rooms and the inability to charge mobile phones for emergency calls. Today, we are here to end this darkness – with light. And not just any light, but clean, healthy and sustainable electricity, delivered in a yellow box and made available to every public health facility in need. This light ensures that deliveries and night-time care are no longer feared.”  Expected results by mid-2027  80 healthcare facilities equipped with Solar Suitcases  26 solar technicians certified to install and maintain Solar Suitcases  The Foundation launched a partnership with We Care Solar in 2024, supporting their Light Every Birth initiative. This marks our inaugural collaboration under  240 health facility staff trained to operate Solar Suitcases FRANCIS KACHIPIRA MIDWIFE  'It was terrifying. You fear for the mother and wonder, ‘What if something goes wrong in the dark?’ When we got the Solar Suitcase, we were relieved to have uninterrupted light. The problem is now a thing of the past.' Working at a health centre in Lilongwe, Malawi, Francis was previously forced to deliver babies by candlelight and phone torches due to unreliable power sources – a race against darkness.  240,000 women and newborns served in the first five years of using Solar Suitcases"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  11  ANNUAL REPORT 2024  PUMA ENERGY’S WE CARE SOLAR STAFF FUNDRAISER In August 2024, We Care Solar held an event to celebrate the launch of its Light Every Birth initiative in Malawi. One member of the Blantyre, Malawi Puma Energy team attended and felt inspired to contribute.  the Puma Energy Foundation strategic theme of clean energy access for remote health facilities. We Care Solar’s Solar Suitcase® is a practical, compact and low-cost solution that is easy to install and maintain. It includes solar panels, a 12V battery, medical procedure lights, medical devices including a foetal Doppler, and a range of sockets and charging capabilities. Through the partnership, 80 remote and off-grid health facilities will be equipped with Solar Suitcases, 50 of them in Malawi and 30 in Tanzania. In 2024, work focused on launching the Light Every Birth programme in Malawi. This involved the vital process of planning and engaging stakeholders to ensure successful nationwide adoption and create a task force. Research included local maternal and newborn healthcare data, availability of electricity, key contacts and partners, and other country-specific considerations. The Solar Suitcases funded by the Puma Energy Foundation have entered the manufacturing stage, with installation starting in early 2025. By mid-2025, 50 health facilities will be equipped with Solar Suitcases in Malawi, staff will be trained in optimal use of the system, and local technicians will be certified to maintain the suitcases.  At the request of the local Puma Energy team, We Care Solar’s Country Programme Manager Eunice Priscilla Mwandira spoke to the office about how solarpowered devices transform maternal and newborn care. When the Foundation organised a staff fundraiser in collaboration with Puma Energy, the team responded generously. Thanks to staff donations from different offices around the world, the fundraiser raised USD 13,166, which the Foundation then matched, bringing the total to over USD 26,000. This funding will equip seven additional health facilities in Malawi with lifesaving solar-powered suitcases, in addition to the impact that will be achieved through the Foundation’s core partnership."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 12-title" style="top:111px;left:-164px;" src="/2024/static/_content/12-title-1.png"/>
      <img class="abs halfScaleC 12-title" style="top:146px;left:-172px;" src="/2024/static/_content/12-title-2.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg12Anim = new TimelineMax();
        pg12Anim.staggerFromTo(cOf("12-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
        }

        function onPageLeave() {
        pg12Anim.stop();
        }
      `,
      "searchText": "12  EMPOWERING WOMEN TO TACKLE ENERGY POVERTY SOLAR SISTER PROGRAMME: WOMEN ENTREPRENEURS BRINGING CLEAN ENERGY ACCESS TO REMOTE COMMUNITIES LOCATION: Tanzania"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 13-quote" style="top:128px;left:72px;" src="/2024/static/_content/13-quote-1.png"/>
      <img class="abs halfScale 13-text" style="top:281px;left:421px;" src="/2024/static/_content/13-subtitle-1.png"/>
      <img class="abs halfScaleC 13-icon" style="top:302px;left:450px;" src="/2024/static/_content/13-icon-1.png"/>
      <img class="abs halfScaleC 13-text" style="top:351px;left:348px;" src="/2024/static/_content/13-icon-caption-1.png"/>
      <img class="abs halfScaleC 13-icon" style="top:383px;left:450px;" src="/2024/static/_content/13-icon-2.png"/>
      <img class="abs halfScaleC 13-text" style="top:426px;left:353px;" src="/2024/static/_content/13-icon-caption-2.png"/>
      <img class="abs halfScaleC 13-icon" style="top:477px;left:450px;" src="/2024/static/_content/13-icon-3.png"/>
      <img class="abs halfScaleC 13-text" style="top:527px;left:357px;" src="/2024/static/_content/13-icon-caption-3.png"/>
      <img class="abs halfScale 13-text" style="top:586px;left:421px;" src="/2024/static/_content/13-subtitle-2.png"/>
      <img class="abs halfScaleC 13-icon" style="top:595px;left:450px;" src="/2024/static/_content/13-icon-4.png"/>
      <img class="abs halfScaleC 13-text" style="top:633px;left:346px;" src="/2024/static/_content/13-icon-caption-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg13Anim = new TimelineMax();
        pg13Anim.fromTo(cOf("13-quote"), 0.6, {opacity:0, y: -50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("13-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)
        .staggerFromTo(cOf("13-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5);
        }

        function onPageLeave() {
        pg13Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  13  ANNUAL REPORT 2024  An important part of the training is learning life skills. How to handle yourself, how to approach new people. I was very shy, but now I can greet people confidently. I like the job because I like telling customers about the benefits. When they buy, I feel good.” LEONIDA ODUR, SOLAR SISTER ENTREPRENEUR  Since 2010, Solar Sister has worked to fight energy poverty in sub-Saharan Africa by recruiting, training and supporting women entrepreneurs to create clean energy distribution businesses. Our partnership focuses this work on last-mile Tanzanian communities. To date, Solar Sister has supported 5,000 women to start clean energy businesses in Tanzania. Together, these entrepreneurs have provided energy access to more than 2.6 million people, bringing life-changing clean energy access to the most underserved communities. Our funding supports the Business Booster aspect of the project. This provides advanced training modules to any entrepreneur after one year of business. Many experienced Solar Sister entrepreneurs are also keen to expand their business by offering larger, more expensive products, such as clean cookstoves and solar home systems. While these have a higher profit margin, they present a significantly higher investment. Business Booster loans have been made available, as well as product research and advice. The second strand of the Business Booster scheme is the Digitizing Women Entrepreneurs project. The women Solar Sister works with are impacted by the digital gender divide, with less than 10% having access to smartphones, and over two thirds of those with access sharing the device. Digital tools are critical for business success, and Solar Sister entrepreneurs who own smartphones earn an average of 80% more. In 2024, work focused on digital training for all entrepreneurs with a smartphone, ensuring the learning has practical applications, as well as continuing to expand access for those without a device.  Partnership achievements in 2024  403 entrepreneurs received advanced business training  153 of these entrepreneurs trained in comprehensive digital literacy skills  8,541 clean energy access products sold Expected results by 2025  60,719 solar products sold, providing clean energy access to people in last-mile communities"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 14-title" style="top:124px;left:56px;" src="/2024/static/_content/14-title-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg14Anim = new TimelineMax();
        pg14Anim.fromTo(cOf("14-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);
        }

        function onPageLeave() {
        pg14Anim.stop();
        }
      `,
      "searchText": "14  SOLAR ENERGY TRAINING FOR YOUNG PEOPLE YOUNG AFRICA PROGRAMME: PROMOTING YOUTH EMPLOYMENT IN THE GREEN ECONOMY LOCATION: Mozambique  Since 2017, over 1.3 million people have been displaced due to ongoing conflict in Mozambique’s Cabo Delgado province, disrupting lives and livelihoods, and affecting healthcare, education and food security. Compounding this crisis, only 14.9% of the population in the northern provinces have access to electricity, leaving approximately 13.6 million people without modern energy solutions. In response to the critical shortage of a qualified workforce in renewable energy and the immense potential to support sustainable development, Young Africa trains youth in Northern Mozambique as solar technicians. It aims to foster resilience, environmental stewardship and economic empowerment. The project uses innovative mobile training units to deliver professional vocational education directly to underserved and conflict-affected areas. The mobile nature of these units ensures communities are reached where travel and access might otherwise be barriers. Learning is hands-on and flexible, following a solar energy curriculum aligned with industry demands. Students benefit from connections with local employers and businesses. Start-up kits and mentoring are provided for graduates who want to pursue self-employed careers. The mobile units also host travelling community awareness sessions. These aim to inform local people about solar energy, its benefits, costs and availability. This includes demonstrations to show the ways they can reduce energy costs, as well as easy-to-understand leaflets in local languages. These events act as a dual learning experience for students too, enabling them to build their knowledge of solar products and their maintenance."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 15-quote" style="top:116px;left:72px;" src="/2024/static/_content/15-quote-1.png"/>
      <img class="abs halfScale 15-text" style="top:281px;left:421px;" src="/2024/static/_content/15-subtitle-1.png"/>
      <img class="abs halfScaleC 15-icon" style="top:303px;left:450px;" src="/2024/static/_content/15-icon-1.png"/>
      <img class="abs halfScale 15-text" style="top:364px;left:424px;" src="/2024/static/_content/15-icon-caption-1.png"/>
      <img class="abs halfScaleC 15-icon" style="top:384px;left:450px;" src="/2024/static/_content/15-icon-2.png"/>
      <img class="abs halfScale 15-text" style="top:444px;left:457px;" src="/2024/static/_content/15-icon-caption-2.png"/>
      <img class="abs halfScaleC 15-icon" style="top:465px;left:450px;" src="/2024/static/_content/15-icon-3.png"/>
      <img class="abs halfScale 15-text" style="top:526px;left:435px;" src="/2024/static/_content/15-icon-caption-3.png"/>
      <img class="abs halfScale 15-text" style="top:587px;left:421px;" src="/2024/static/_content/15-subtitle-2.png"/>
      <img class="abs halfScaleC 15-icon" style="top:594px;left:450px;" src="/2024/static/_content/15-icon-4.png"/>
      <img class="abs halfScale 15-text" style="top:656px;left:411px;" src="/2024/static/_content/15-icon-caption-4.png"/>

      `,
      "script": `
        function onPageEnter() {
        pg15Anim = new TimelineMax();
        pg15Anim.fromTo(cOf("15-quote"), 0.6, {opacity:0, y: -50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("15-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)
        .staggerFromTo(cOf("15-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5);
        }

        function onPageLeave() {
        pg15Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  15  ANNUAL REPORT 2024  I had always dreamed of graduating, but financial constraints, lack of opportunity and becoming a mother at a young age prevented me. When I heard about the opportunity for vocational training in electricity, I was eager to attend. I became one of the best graduates in my class. Now, not only do I earn a stable income, but I also mentor new trainees, which allows me to share my knowledge and encourage others to follow their dreams.” TEODORA GERALDO, MENTOR AND FORMER TRAINEE  Partnership achievements in 2024  123 new solar technicians or electricians  14 business start-up kits  2,085 community members informed about solar solutions Expected results by 2025  140 youth graduated as solar technicians and 4,000 community members informed about solar solutions"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 16-title" style="top:124px;left:56px;" src="/2024/static/_content/16-title-1.png"/>
      <img class="abs halfScale 16-text" style="top:281px;left:406px;" src="/2024/static/_content/16-subtitle-1.png"/>
      <img class="abs halfScaleC 16-icon" style="top:301px;left:436px;" src="/2024/static/_content/16-icon-1.png"/>
      <img class="abs halfScale 16-text" style="top:361px;left:423px;" src="/2024/static/_content/16-icon-caption-1.png"/>
      <img class="abs halfScaleC 16-icon" style="top:384px;left:436px;" src="/2024/static/_content/16-icon-2.png"/>
      <img class="abs halfScale 16-text" style="top:446px;left:414px;" src="/2024/static/_content/16-icon-caption-2.png"/>
      <img class="abs halfScaleC 16-icon" style="top:479px;left:436px;" src="/2024/static/_content/16-icon-3.png"/>
      <img class="abs halfScale 16-text" style="top:539px;left:408px;" src="/2024/static/_content/16-icon-caption-3.png"/>
      <img class="abs halfScaleC 16-icon" style="top:597px;left:436px;" src="/2024/static/_content/16-icon-4.png"/>
      <img class="abs halfScale 16-text" style="top:587px;left:407px;" src="/2024/static/_content/16-subtitle-2.png"/>
      <img class="abs halfScale 16-text" style="top:658px;left:411px;" src="/2024/static/_content/16-icon-caption-4.png"/>

      `,
      "script": `
        function onPageEnter() {
        pg16Anim = new TimelineMax();
        pg16Anim.fromTo(cOf("16-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("16-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)
        .staggerFromTo(cOf("16-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5);
        }

        function onPageLeave() {
        pg16Anim.stop();
        }
      `,
      "searchText": "16  RURAL COMMUNITY ENERGY TRANSITION BAREFOOT COLLEGE INTERNATIONAL PROGRAMME: RURAL SOLAR ELECTRIFICATION AND WOMEN’S EMPOWERMENT LOCATION: Guatemala  Across the remote Quiché department of Guatemala, more than 35,000 homes do not have access to electricity. Our partner Barefoot College International (BCI) established a vocational training centre, providing leadership and solar engineering training for local Ixil Mayan women. This helps empower marginalised women who have limited opportunities and access to basic services, enabling them to positively transform their lives and communities.  Partnership achievements in 2024  The first cohort of 12 women graduated from the 10-week residential training course in 2023. These women came from off-grid villages and earned less than USD 400 a year. Due to limited access to education, only two thirds of the training participants knew how to read Spanish and only one third could write in it. The training not only provided participants with technical expertise, but it also provided them with life skills and newfound confidence. In many cases, they were empowered to transform their lives.  12 women active as solar technicians  From May 2024, the women began installing solar home systems in six communities. This reached a total of 350 households. Another cohort of students is now being coordinated for 2025. In 2024, BCI was honoured by the World Energy Council and given the Humanizing Energy Award for its pioneering work. This award celebrates leadership in involving people and communities in a fast, fair and far-reaching energy transition.  CATARINA CEDILLO RAMIREZ ARTISAN  Catarina lives in Vichemal, a small village in Guatemala, where she crafts wicker baskets and sells them at the market. Previously, she relied on candles and wood for lighting and walked an hour to charge her phone. The introduction of a solar home lighting system transformed her life. Reliable, safe lighting saves money, gives her time back, and reduces fire risk and indoor pollution. Her children can now study comfortably in the evenings. This change has greatly enhanced her family’s quality of life.  182 households equipped with full solar home sytems  910 people provided with clean energy access Expected results by 2025  312 households reached, providing energy access to 1,560 people"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  ANNUAL REPORT 2024  17"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 18-box" style="top:112px;left:50px;" src="/2024/static/_content/18-bg-1.png"/>
      <img class="abs halfScale 18-title" style="top:150px;left:77px;" src="/2024/static/_content/18-title-1.png"/>
      <img class="abs halfScale 18-text" style="top:365px;left:84px;" src="/2024/static/_content/18-text-1.png"/>

      `,
      "script": `
        function onPageEnter() {
        pg18Anim = new TimelineMax();
        pg18Anim.fromTo(cOf("18-box"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .fromTo(cOf("18-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)
        .fromTo(cOf("18-text"), 0.7, {opacity:0, y: 40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
        }

        function onPageLeave() {
        pg18Anim.stop();
        }
      `,
      "searchText": "18  ROAD SAFETY OUR PARTNER organisations focus on road safety education and safe  mobility solutions in low- and middle-income countries in Africa and Latin America. They work to raise awareness, advocate for best practices and provide innovative transport solutions, particularly for vulnerable and last-mile communities."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
    
      <img class="abs halfScaleC 19-icon" style="top:90px;left:460px;" src="/2024/static/_content/19-icon-1.png"/>
      <img class="abs halfScale 19-text" style="top:190px;left:461px;" src="/2024/static/_content/19-subtitle-1.png"/>
      <img class="abs halfScale 19-text" style="top:237px;left:458px;" src="/2024/static/_content/19-caption-1.png"/>
      <img class="abs halfScale 19-text" style="top:292px;left:473px;" src="/2024/static/_content/19-caption-2.png"/>
      <img class="abs halfScale 19-text" style="top:346px;left:468px;" src="/2024/static/_content/19-caption-3.png"/>
      <img class="abs halfScale 19-text" style="top:411px;left:443px;" src="/2024/static/_content/19-caption-4.png"/>
      <img class="abs halfScale 19-text" style="top:477px;left:450px;" src="/2024/static/_content/19-subcaption-1.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg19Anim = new TimelineMax();
        pg19Anim.fromTo(cOf("19-icon"), 0.6,  {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
        .staggerFromTo(cOf("19-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.1);
        }

        function onPageLeave() {
        pg19Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  19  ANNUAL REPORT 2024  GLOBAL CHALLENGES 1.3  million deaths annually from traffic accidents  10th  leading cause of death worldwide  #1  cause of death for children and youth aged 5-29 years  90%  of fatal accidents in low- and middle-income countries*  * All statistics from the World Health Organization’s Global Plan – Decade of Action for Road Safety 2021-2030"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 20-title" style="top:124px;left:56px;" src="/2024/static/_content/20-title-1.png"/>
      <img class="abs halfScale 20-text" style="top:281px;left:406px;" src="/2024/static/_content/20-subtitle-1.png"/>
      <img class="abs halfScaleC 20-icon" style="top:301px;left:436px;" src="/2024/static/_content/20-icon-1.png"/>
      <img class="abs halfScale 20-text" style="top:361px;left:420px;" src="/2024/static/_content/20-icon-caption-1.png"/>
      <img class="abs halfScaleC 20-icon" style="top:420px;left:436px;" src="/2024/static/_content/20-icon-2.png"/>
      <img class="abs halfScale 20-text" style="top:481px;left:429px;" src="/2024/static/_content/20-icon-caption-2.png"/>
      <img class="abs halfScaleC 20-icon" style="top:517px;left:436px;" src="/2024/static/_content/20-icon-3.png"/>
      <img class="abs halfScale 20-text" style="top:577px;left:418px;" src="/2024/static/_content/20-icon-caption-3.png"/>
      <img class="abs halfScaleC 20-icon" style="top:646px;left:436px;" src="/2024/static/_content/20-icon-4.png"/>
      <img class="abs halfScale 20-text" style="top:637px;left:407px;" src="/2024/static/_content/20-subtitle-2.png"/>
      <img class="abs halfScale 20-text" style="top:706px;left:403px;" src="/2024/static/_content/20-icon-caption-4.png"/>
      
      `,
      "script": `
        function onPageEnter() {
        pg20Anim = new TimelineMax();
        pg20Anim.fromTo(cOf("20-title"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("20-text"), 0.6, {opacity:0, y: -40}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.2)
        .staggerFromTo(cOf("20-icon"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.5);
        }

        function onPageLeave() {
        pg20Anim.stop();
        }
      `,
      "searchText": "20  DEVELOPING DRIVER TRAINING FOR ROAD SAFETY TRANSAID PROGRAMME: ENHANCING HEAVY GOODS VEHICLE DRIVER TRAINING STANDARDS LOCATION: Ghana  Having partnered with Transaid since 2021, we renewed funding for its Ghana programme in 2024. As our flagship road safety partner, Transaid developed a curriculum and trainer’s manual for heavy goods vehicle (HGV) drivers during the previous phase. Officially launched in June 2024, it is the first standard of its kind in Ghana, mandating annual theory and practical refresher training for all drivers. With growing demand for freight transport drivers due to the growth of Tema port and other major infrastructure projects, this training is crucial for ensuring road and driver safety. Transaid is collaborating with local transport groups and the government to support the nationwide rollout of the standard while building examiner capacity. In 2024, the four Ghanaian Master Trainers continue to strengthen in-house training for transporters. Additionally, 13 DVLA examiners were introduced to the new standard. The launch event was attended by 118 dignitaries, including Ghana's Deputy Ministry of Transport and the DVLA's Chief Executive and Board Chairperson. The project is creating four HGV refresher modules, training six more HGV driver trainers in the Ashanti region, establishing a national HGV trainer facility, building the capacity of 12 additional examiners, and reaching 8,000 HGV drivers nationwide. The goal is to standardise HGV driver training across the region and use Ghana's work as a model for other West African countries.  FRANCIS QUARTEY HGV DRIVER TRAINER  Francis Quartey, an HGV driver since 1998 and now a trainer, attended Transaid’s Training of Trainers. He now structures his lessons with plans and emphasizes practical training alongside theory. He believes Transaid's new HGV training standard will reduce road traffic accidents in Ghana, particularly those involving dangerous goods. “If we test, test, test, before the driver is put on the road, then I think we’ll reduce a lot of crashes.”  Partnership achievements in 2024  Rollout of the Heavy Goods Vehicle (HGV) driver training standard, first of its kind for Ghana  4 Master Trainers received refreshed training  13 government examiners introduced to the new standard Expected results by 2027  8,000 HGV drivers reached"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  ANNUAL REPORT 2024  In July 2024, drivers gathered for the launch of Ghana's new truck driver training manual. This initiative enhances road safety and driver competency, with the Foundation extending its support until 2027 to improve training standards across West Africa.  21"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 22-title" style="top:124px;left:59px;" src="/2024/static/_content/22-title-1.png"/>
      `,
      "script": `
        function onPageEnter() {
        pg22Anim = new TimelineMax();
        pg22Anim.fromTo(cOf("22-title"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
        pg22Anim.stop();
        }
      `,
      "searchText": "22  TRANSFORMING RURAL ACCESS TO HEALTHCARE WORLD BICYCLE RELIEF PROGRAMME: WHEELS FOR HEALTH LOCATION: Zambia"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 23-subtitle" style="top:402px;left:437px;" src="/2024/static/_content/23-subtitle-1.png"/>
        <img class="abs halfScaleC 23-icon" style="top:423px;left:450px;" src="/2024/static/_content/23-icon-1.png"/>
        <img class="abs halfScaleC 23-icon" style="top:505px;left:450px;" src="/2024/static/_content/23-icon-2.png"/>
        <img class="abs halfScaleC 23-icon" style="top:586px;left:450px;" src="/2024/static/_content/23-icon-3.png"/>
        <img class="abs halfScaleC 23-icon" style="top:655px;left:450px;" src="/2024/static/_content/23-icon-4.png"/>
        <img class="abs halfScale 23-icon-caption" style="top:484px;left:414px;" src="/2024/static/_content/23-icon-caption-1.png"/>
        <img class="abs halfScale 23-icon-caption" style="top:565px;left:414px;" src="/2024/static/_content/23-icon-caption-2.png"/>
        <img class="abs halfScale 23-icon-caption" style="top:646px;left:421px;" src="/2024/static/_content/23-icon-caption-3.png"/>
        <img class="abs halfScale 23-icon-caption" style="top:716px;left:422px;" src="/2024/static/_content/23-icon-caption-4.png"/>
      `,
      "script": `
        function onPageEnter() {
        pg23Anim = new TimelineMax();
        pg23Anim.fromTo(cOf("23-subtitle"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .staggerFromTo(cOf("23-icon"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)
        .staggerFromTo(cOf("23-icon-caption"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.2)
        }

        function onPageLeave() {
        pg23Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  23  ANNUAL REPORT 2024  In 2024, our new partnership with World Bicycle Relief, called Wheels for Health, was approved. This new agreement builds on the success of our 2021-2023 partnership. It is based in rural Zambia, where communities face challenges in accessing healthcare. Distance and transport are major issues, and women are especially affected. Community-based volunteers are essential in bringing healthcare to these areas, but without reliable transport, they struggle to reach patients. This leads to delays in care, inadequate disease testing, limited nutrition support for pregnant women and new mothers, and higher mortality rates.  391 bikes provided to community-based volunteers  Wheels for Health provides bicycles to community-based volunteers across six districts in Copperbelt, Muchinga and northern provinces, enabling them to reach more households more quickly. To ensure bicycles can be maintained long-term, World Bicycle Relief trains local mechanics near targeted health centres. This ensures access to affordable bike repairs and creates additional income for local community members.  45% reduction in average travel time for health workers  Bicycles are provided to the community-based volunteers through “service-toown agreements”, allowing them to own the bikes after two years if they maintain them and use them primarily for work. This reduces the need for additional funding, ensuring the project becomes self-sustaining. Known as Buffalo Bicycles, the bikes are durable and designed for challenging terrain while being low-cost and sustainable to run. By the end of our partnership, it is estimated that 51,800 households will be reached by participating community-based volunteers, leading to 195,500 people with improved access to healthcare services.  Expected results by end-2026  50% more patients served  195,500 rural residents reached by health workers"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 24-title" style="top:124px;left:143px;" src="/2024/static/_content/24-title-1.png"/>
        <img class="abs halfScale 24-side-title" style="top:115px;left:33px;" src="/2024/static/_content/24-side-title-1.png"/>
        <img class="abs halfScale 24-subtitle" style="top:281px;left:407px;" src="/2024/static/_content/24-subtitle-1.png"/>
        <img class="abs halfScaleC 24-icon-1" style="top:300px;left:436px;" src="/2024/static/_content/24-icon-1.png"/>
        <img class="abs halfScaleC 24-icon-2" style="top:384px;left:436px;" src="/2024/static/_content/24-icon-2.png"/>
        <img class="abs halfScale 24-icon-caption-1" style="top:362px;left:437px;" src="/2024/static/_content/24-icon-caption-1.png"/>
        <img class="abs halfScale 24-icon-caption-2" style="top:449px;left:405px;" src="/2024/static/_content/24-icon-caption-2.png"/>
        <img class="abs halfScale 24-quote" style="top:539px;left:396px;" src="/2024/static/_content/24-quote-1.png"/>
      `,
      "script": `
        function onPageEnter() {
        pg24Anim = new TimelineMax();
        pg24Anim.fromTo(cOf("24-title"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        pg24Anim.fromTo(cOf("24-side-title"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.8)
        .fromTo(cOf("24-subtitle"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        .fromTo(cOf("24-icon-1"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)
        .fromTo(cOf("24-icon-2"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.9)
        .fromTo(cOf("24-icon-caption-1"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        .fromTo(cOf("24-icon-caption-2"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        .fromTo(cOf("24-quote"), 0.8, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)
        }

        function onPageLeave() {
        pg24Anim.stop();
        }
      `,
      "searchText": "OTHER PARTNERS  24  TECH JOBS FOR VULNERABLE YOUTH CONEXION PROGRAMME: TICONGLE LOCATION: El Salvador  Unemployment among young people in El Salvador is as high as 46%, with rates even higher for underprivileged youth. Many lack the necessary resources to access quality education, limiting job opportunities. Our partner CONEXION provides a chance for vulnerable youth to learn IT skills, a rapidly growing industry that has an increasing demand for workers. CONEXION offers accelerated boot camps in digital technology that allow participants to develop a wide range of vocational skills through the TICONGLE programme. These boot camps provide participants with the technical knowledge and practical experience needed to work in IT, without the need for prior knowledge or education in the sector. They also include soft skill training for the business world, interview preparation and access to connections within the IT sector. Training is provided to women, youth and adolescents, aiming to improve the socioeconomic lives of all participants.  Partnership achievements in 2024  135 young people trained  62% of all trainees to date have secured employment, and 100% have completed internships  Thanks to the Puma Energy Foundation support, we have impacted the lives of more than 135 young people by improving their digital skills and providing employment opportunities.” ETHEL DE KURI, DIRECTOR OF DEVELOPMENT AND PARTNERSHIPS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:124px;left:74px;" src="/2024/static/_content/25-title-1.png"/>
        <img class="abs halfScale 25-subtitle" style="top:282px;left:421px;" src="/2024/static/_content/25-subtitle-1.png"/>
        <img class="abs halfScaleC 25-icon-1" style="top:303px;left:450px;" src="/2024/static/_content/25-icon-1.png"/>
        <img class="abs halfScaleC 25-icon-2" style="top:396px;left:450px;" src="/2024/static/_content/25-icon-2.png"/>
        <img class="abs halfScale 25-icon-caption-1" style="top:364px;left:432px;" src="/2024/static/_content/25-icon-caption-1.png"/>
        <img class="abs halfScale 25-icon-caption-2" style="top:457px;left:426px;" src="/2024/static/_content/25-icon-caption-2.png"/>
      `,
      "script": `
        function onPageEnter() {
        pg25Anim = new TimelineMax();
        pg25Anim.fromTo(cOf("25-title"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .fromTo(cOf("25-subtitle"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        .fromTo(cOf("25-icon-1"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)
        .fromTo(cOf("25-icon-2"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.9)
        .fromTo(cOf("25-icon-caption-1"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        .fromTo(cOf("25-icon-caption-2"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        }

        function onPageLeave() {
        pg25Anim.stop();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  25  ANNUAL REPORT 2024  CHILD BURN PREVENTION AND EDUCATION APROQUEN, INC PROGRAMME: PRECAUTION, PREVENTION & RESPONSE: A COMPREHENSIVE APPROACH TO BURN PREVENTION LOCATION: Nicaragua  In Latin America, more children die each year from burns than HIV/AIDS and malaria combined. Accidental burns are the second most common cause of death, mainly affecting children between ages one to nine. Many families are not properly educated on how to immediately treat a burn and cannot afford the costs of injury repair. APROQUEN addresses this issue by providing free comprehensive care to children suffering from burn injuries.  Partnership achievements in 2024  In 2024, APROQUEN launched the third phase of its burn prevention initiative, focusing on teaching children, parents, teachers and community leaders how to prevent burns. Burn prevention specialists travel to schools in areas with the highest incidence of paediatric burns. Between May and September 2024, APROQUEN visited 19 schools and provided education to over 2,000 children.  2,055 school-aged children received burn prevention education  Dr Yader Cisneros, who works on the burn prevention team, explains, “I have witnessed firsthand the impact of our educational efforts in communities. Our workshops equip participants with essential knowledge on burn risks, prevention strategies and first aid measures, empowering them to take proactive steps in protecting themselves and others. Seeing the increased awareness and confidence in handling burn-related incidents is incredibly rewarding.” After APROQUEN’s studies showed that young students learn better through play, it implemented interactive burn prevention games in children's workshops. For adults, workshops now take a different approach, focusing on the creation of burn prevention content for social media to broaden awareness. Additionally, these workshops empower community members to become advocates, equipping them with essential knowledge to share with others.  Being part of the burn prevention programme is an honour. It is a noble effort aimed at saving lives and preventing suffering, especially in children. I am proud to contribute to this cause, which is so important for our country and the well-being of the children of Nicaragua.” EDWIN HERNANDEZ, BURN PREVENTION TECHNICAL TEAM MEMBER  112 parents, teachers and community leaders received burn prevention education and training"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 26-title-1" style="top:372px;left:56px;" src="/2024/static/_content/26-title-1.png"/>
        <img class="abs halfScale 26-quote-1" style="top:422px;left:396px;" src="/2024/static/_content/26-quote-1.png"/>
        <img class="abs halfScaleC 26-icon-1" style="top:654px;left:436px;" src="/2024/static/_content/26-icon-1.png"/>
        <img class="abs halfScaleC 26-icon-caption-1" style="top:705px;left:324px;" src="/2024/static/_content/26-icon-caption-1.png"/>
      `,
      "script": `
        function onPageEnter() {
        pg26Anim = new TimelineMax();
        pg26Anim.fromTo(cOf("26-title-1"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        .fromTo(cOf("26-quote-1"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        .fromTo(cOf("26-icon-1"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)
        .fromTo(cOf("26-icon-caption-1"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6)
        }

        function onPageLeave() {
        pg26Anim.stop();
        }
      `,
      "searchText": "26  STAFF ENGAGEMENT In 2024, Puma Energy’s first-ever Charity Committee was established in Port Moresby, Papua New Guinea. Charity Committees are staff volunteer groups that coordinate philanthropic initiatives, including fundraising, within a local Puma Energy office. The Puma Energy Foundation supports these efforts through annual grants to charities chosen by the Committees. In August 2024, four employees in Port Moresby formed their own Charity Committee with help from the Foundation team. For their first initiative, they supported Pamili Ministry Inc. in building and fully equpping a four-in-one classroom for Pirtop Elementary and Primary School on Duke of York Island. This classroom will benefit Pirtop and four nearby villages, providing better learning conditions and reducing the number of school age children missing out on formal education. We hope the generosity of the Port Moresby office inspires other locations to establish their own Charity Committees.  Through this engagement between the Puma Energy Foundation and the Port Moresby Charity Committee, we feel that we can fulfil our purpose to contribute in a special way and create a positive impact on the community.” PORT MORESBY CHARITY COMMITTEE  180 students will benefit from the school premises"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
        <div class="addContentLink" style="top:176px;left:127px;width:75px;height:10px">
        <a href="http://aproquenkids.org" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:187px;left:201px;width:85px;height:10px">
        <a href="http://barefootcollege.org" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:200px;left:124px;width:51px;height:10px">
        <a href="http://conexion.sv/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:211px;left:123px;width:60px;height:10px">
        <a href="http://solarsister.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:223px;left:111px;width:52px;height:10px">
        <a href="http://transaid.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:235px;left:135px;width:67px;height:10px">
        <a href="http://wecaresolar.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:246px;left:159px;width:92px;height:10px">
        <a href="http://worldbicyclerelief.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:258px;left:130px;width:68px;height:10px">
        <a href="http://youngafrica.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:552px;left:163px;width:42px;height:10px">
        <a href="https://touchline.com/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:729px;left:72px;width:115px;height:10px">
        <a href="https://pumaenergyfoundation.org/" target="_blank"></a>
        </div>
        `,
      "script": `
        function onPageEnter() {
        setTimeout(function(){
            addContentLinks();
          },1000)

        }

        function onPageLeave() {
        removeContentLinks();
        }
      `,
      "searchText": "PUMA ENERGY FOUNDATION  ANNUAL REPORT 2024  OUR PARTNERS’ WEBSITES APROQUEN, aproquenkids.org Barefoot College International, barefootcollege.org CONEXION, conexion.sv Solar Sister, solarsister.org Transaid, transaid.org We Care Solar, wecaresolar.org World Bicycle Relief, worldbicyclerelief.org Young Africa, youngafrica.org  PHOTO CREDITS World Bicycle Relief (3, 23) Celine Guerin (5) Brenda Yohana González Calel/Barefoot College (9) Zahara Abdul (11) Celine Guerin (12) YAMoz/Young Africa (14-15) María Ixmukané Hú Caba/Barefoot College (17) Transaid (19-20) Mana Meadows/WBR (22) CONEXION El Salvador (24) APROQUEN (25) Licks Ramani (26) We would like to thank all those who provided photography for this report. Copy, editing, design: Touchline  Puma Energy Foundation 1, rue de Jargonnant 1207 Geneva, Switzerland pumaenergyfoundation.org  27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }

      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
      }

      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }

      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }

      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js